import { render } from "./contact-section.vue?vue&type=template&id=19fd921b"
import script from "./contact-section.vue?vue&type=script&lang=js"
export * from "./contact-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__